<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$t("ui.oxtoeml")')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-2.col-xl-2.mb-1
                b-input-group(:prepend='$t("ui.type")' size="sm")
                  label.type-switch.type-switch-label.type-switch-success.mb-0
                    input(type="checkbox" class="type-switch-input" v-model="full_amount" :disabled="loading")
                    span(class="type-switch-slider" :data-checked="$t('ui.full')" :data-unchecked="$helpers.getLabelName(accountType)")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                SubmitButton(:loading="loading" icon="fa fa-sync" :text="timer + ' ' + $t('ui.seconds')" isModal=false type="button" @click="search")
            b-row
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                .table-sm.table-responsive
                  table#tblList.table.table-hover.table-bordered
                    thead
                      tr
                        //- th.align-middle.text-center.bg-grey-lighter(style="width:4%;") #
                        th.align-middle.text-left.bg-grey-lighter(style="width:10%;") {{ $t("ui.date_time") }}
                        th.align-middle.text-center.bg-grey-lighter(style="width:30%;") {{ $t("ui.match") }}
                        th.align-middle.text-center.bg-grey-transparent-1(style="width:7%;") 1
                        th.align-middle.text-center.bg-grey-transparent-1(style="width:7%;") X
                        th.align-middle.text-center.bg-grey-transparent-1(style="width:7%;") 2
                        th.align-middle.text-center.bg-grey-transparent-3(style="width:7%;") {{ $t("m.LOT_ODD") }}
                        th.align-middle.text-center.bg-grey-transparent-3(style="width:7%;") Diff
                        th.align-middle.text-center.bg-grey-transparent-3(style="width:7%;") {{ $t("m.LOT_EVEN") }}
                        th.align-middle.text-center.bg-grey-transparent-5(style="width:7%;") 1
                        th.align-middle.text-center.bg-grey-transparent-5(style="width:7%;") 2
                    tbody
                      template(v-if="filterLeague()")
                        template(v-for="(league,index) in filterLeague()" :keys="index")
                          tr
                            td.bg-grey-transparent-2(colspan=11) #[b {{ getName(league, 0) }}]
                          template(v-for="(match,index) in filterMatch(league)" :keys="index")
                            tr
                              //- td.align-middle.text-center {{ match }}
                              td.align-middle.text-left {{ getMatchTime(match) }}
                              td.align-middle.text-center {{ getMatchTeam(match) }}
                              td.align-middle.text-center
                                b-link(:class='$helpers.getNumberClass(getBetTypeStock(match, "1X2", 1))' @click='redirectTo(1, match, "1X2")') {{ getBetTypeStock(match, "1X2", 1) }}
                              td.align-middle.text-center
                                b-link(:class='$helpers.getNumberClass(getBetTypeStock(match, "1X2", 3))' @click='redirectTo(3, match, "1X2")') {{ getBetTypeStock(match, "1X2", 3) }}
                              td.align-middle.text-center
                                b-link(:class='$helpers.getNumberClass(getBetTypeStock(match, "1X2", 2))' @click='redirectTo(2, match, "1X2")') {{ getBetTypeStock(match, "1X2", 2) }}
                              td.align-middle.text-center
                                span(:class='$helpers.getNumberClass(getBetTypeStock(match, "OE", 1))') {{ getBetTypeStock(match, "OE", 1) }}
                              td.align-middle.text-center
                                b-link(:class='$helpers.getNumberClass(getOEDiff(match, "OE"))' @click='redirectTo(0, match, "OE")') {{ getOEDiff(match, "OE") }}
                              td.align-middle.text-center
                                span(:class='$helpers.getNumberClass(getBetTypeStock(match, "OE", 2))') {{ getBetTypeStock(match, "OE", 2) }}
                              td.align-middle.text-center
                                b-link(:class='$helpers.getNumberClass(getBetTypeStock(match, "ML", 1))' @click='redirectTo(0, match, "ML")') {{ getBetTypeStock(match, "ML", 1) }}
                              td.align-middle.text-center
                                b-link(:class='$helpers.getNumberClass(getBetTypeStock(match, "ML", 2))' @click='redirectTo(0, match, "ML")') {{ getBetTypeStock(match, "ML", 2) }}
                            tr(v-if="isHalfExist(match)")
                              //- td.align-middle.text-center {{ match }}
                              td.align-middle.text-left {{ getMatchTime(match) }}
                              td.align-middle.text-center {{ getMatchTeam(match) }} ({{ $t("ui.half_time") }})
                              td.align-middle.text-center
                                b-link(:class='$helpers.getNumberClass(getBetTypeStock(match, "1X2H", 1))' @click='redirectTo(1, match, "1X2H")') {{ getBetTypeStock(match, "1X2H", 1) }}
                              td.align-middle.text-center
                                b-link(:class='$helpers.getNumberClass(getBetTypeStock(match, "1X2H", 3))' @click='redirectTo(3, match, "1X2H")') {{ getBetTypeStock(match, "1X2H", 3) }}
                              td.align-middle.text-center
                                b-link(:class='$helpers.getNumberClass(getBetTypeStock(match, "1X2H", 2))' @click='redirectTo(2, match, "1X2H")') {{ getBetTypeStock(match, "1X2H", 2) }}
                              td.align-middle.text-center
                                span(:class='$helpers.getNumberClass(getBetTypeStock(match, "OEH", 1))') {{ getBetTypeStock(match, "OEH", 1) }}
                              td.align-middle.text-center
                                b-link(:class='$helpers.getNumberClass(getOEDiff(match, "OEH"))' @click='redirectTo(0, match, "OEH")') {{ getOEDiff(0, match, "OEH") }}
                              td.align-middle.text-center
                                span(:class='$helpers.getNumberClass(getBetTypeStock(match, "OEH", 2))') {{ getBetTypeStock(match, "OEH", 2) }}
                              td.align-middle.text-center
                                b-link(:class='$helpers.getNumberClass(getBetTypeStock(match, "MLH", 1))' @click='redirectTo(0, match, "MLH")') {{ getBetTypeStock(match, "MLH", 1) }}
                              td.align-middle.text-center
                                b-link(:class='$helpers.getNumberClass(getBetTypeStock(match, "MLH", 2))' @click='redirectTo(0, match, "MLH")') {{ getBetTypeStock(match, "MLH", 2) }}
                      template(v-else)
                        tr(style="background-color:#f2f4f5")
                          td.align-middle.text-center(colspan=11)
                            div.my-2 {{ $t("message.no_records") }}
</template>

<script>
import config from "@/config"
import SubmitButton from "@/library/SubmitButton.vue"

export default {
  components: {
    SubmitButton
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      betList: [],
      matchList: [],
      full_amount: true,
      pulling: null,
      countdown: null,
      timer: 60,
      betListDetail: {
        full_amount: true,
        bet_type: "",
        match_id: 0,
        home_away: 0
      },
      match: [],
      league: []
    };
  },
  validations: {},
  computed: {
    language() {
      if(this.$store.getters.language == "zh") {
        return "cn"
      } else {
        return this.$store.getters.language
      }
    },
    accountType() {
      return this.$store.getters.accountType
    }
  },
  mounted: function() {
    this.search()
    this.countdown = setInterval(() => {
      this.timer -= 1
    }, 1 * 1000)
    this.pulling = setInterval(() => {
      this.search()
      this.timer = 60
    }, 1 * 61000)
  },
  beforeDestroy: function() {
    clearInterval(this.pulling)
    clearInterval(this.countdown)
  },
  methods: {
    redirectTo: function(home_away, match_id, bet_type) {
      this.betListDetail.full_amount = (this.full_amount) ? 1 : 0
      this.betListDetail.bet_type = bet_type
      this.betListDetail.match_id = match_id
      this.betListDetail.home_away = home_away
      this.$store.dispatch("layout/setBetListDetail", this.betListDetail)
      this.$router.push("/betListOXTOEMLDetails")
    },
    filterLeague: function() {
      if(this.betList.length > 0) {
        return this.betList.map(item => item.league_id).filter((value, index, self) => self.indexOf(value) === index)
      }
    },
    filterMatch: function(league) {
      if(this.betList.length > 0) {
        let allMatch = this.betList.filter((value, index, self) => self[index].league_id == league)
        return allMatch.map(item => item.match_id).filter((value, index, self) => self.indexOf(value) === index)
      }
    },
    getMatchTime: function(match) {
      if(this.betList.length > 0) {
        let matchLeague = this.betList.filter((value, index, self) => value.match_id == match)
        return this.$moment(matchLeague[0].match_time).format("YYYY-MM-DD HH:mm:ss")
      }
    },
    getMatchTeam: function(match) {
      if(this.betList.length > 0) {
        return this.getName(match, 1) + " vs " + this.getName(match, 2)
      }
    },
    getBetTypeStock: function(match_id, bet_type, home_away) {
      if(this.betList.length > 0) {
        let result = this.betList.filter((value, index, self) => self[index].match_id == match_id && self[index].home_away == home_away && self[index].bet_type == bet_type)
        return (result.length) ? (this.full_amount) ? Math.ceil(result[0].bet_member) : Math.ceil(result[0].bet_agent) : 0
      }
    },
    getOEDiff: function(match_id, bet_type) {
      let result = []
      let isHome = 0
      let isAway = 0
      if(this.betList.length > 0) {
        result = this.betList.filter((value, index, self) => self[index].match_id == match_id && self[index].bet_type == bet_type)
        for(let i in result) {
          if (result[i].home_away == 1) {
            isHome = (this.full_amount) ? Math.ceil(result[i].bet_member) : Math.ceil(result[i].bet_agent)
          } else {
            isAway = (this.full_amount) ? Math.ceil(result[i].bet_member) : Math.ceil(result[i].bet_agent)
          }
        }
        return isHome - isAway
      }
    },
    isHalfExist: function(match_id) {
      let result = this.betList.filter((value, index, self) => self[index].match_id == match_id && (self[index].bet_type == "1X2H" || self[index].bet_type == "OEH" || self[index].bet_type == "MLH"))
      return (result.length) ? true : false
    },
    getName: function(id, mode) {
      let name = ""
      if(mode == 0) {
        this.league.forEach(x => {
          if(x.league_id == id) {
            name = (x["name_" + this.language]) ? x["name_" + this.language] : x["name_en"]
          }
        })
      } else {
        this.match.forEach(y => {
          if(y.match_id == id) {
            if (mode == 1) {
              name = (y["home_name_" + this.language]) ? y["home_name_" + this.language] : y["home_name_en"]
            } else {
              name = (y["away_name_" + this.language]) ? y["away_name_" + this.language] : y["away_name_en"]
            }
          }
        })
      }
      return name
    },
    search: function() {
      if (!this.$v.$invalid) {
        let url = config.getStockOEUrl()
        this.loading = true
        this.$store
          .dispatch("user/getStock", { url })
          .then(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
            if (this.submission.success == true) {
              if(response.data.length > 0) {
                this.betList = response.data
                this.betList = this.betList.sort(function(a,b){
                  return new Date(a.match_time) - new Date(b.match_time)
                })
                this.match = response.names.match
                this.league = response.names.league
              } else {
                this.betList = []
                this.match = []
                this.league = []
              }
            } else {
              this.loading = false
              this.submission.success = response.success
              this.submission.status = response.errorTag
            }
          })
          .catch(response => {
            this.loading = false
            this.betList = []
            this.match = []
            this.league = []
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag)
          });
      }
    }
  }
};
</script>